var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-alert',{attrs:{"text":"","prominent":"","type":"error"}},[_vm._v(" "+_vm._s(_vm.$t('page.forbidden.content'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }